@if ((isInitialEmbedRequest || isEmbedRoute) && !isRouteResolved) {
  <div class="embed-loading" aria-label="Loading embedded content">
    <div class="embed-loading-spinner"></div>
  </div>
} @else if (!isEmbedRoute) {
  @if (authorized) {
    <header>
      <app-buckeye-alert></app-buckeye-alert>
      <app-osu-navbar></app-osu-navbar>
    </header>
    <app-navbar></app-navbar>
    <main>
      @if (isHomePage) {
        <app-announcements-header></app-announcements-header>
      }
      <router-outlet></router-outlet>
      <app-scroll-to-top></app-scroll-to-top>
    </main>
    <footer>
      <app-footer></app-footer>
    </footer>
  } @else {
    <div id="auth-overlay">
      <mat-form-field>
        <mat-label>Enter your OSU name.# to continue</mat-label>
        <input
          matInput
          [(ngModel)]="username"
          placeholder="buckeye.1"
          (keyup.enter)="authorize()"
          />
        @if (failedAttempts > 0) {
          <mat-hint>
            {{ failedAttempts - 1 }} failed attempt{{
            failedAttempts > 2 ? "s" : ""
            }}
          </mat-hint>
        }
      </mat-form-field>
      <button mat-flat-button color="primary" (click)="authorize()">
        Submit
      </button>
    </div>
  }
} @else {
  <div class="m-2">
    <router-outlet></router-outlet>
  </div>
}
